"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomAvatar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _endpoints = require("../../../utils/endpoints");
var _utils = require("../utils");
var _components = require("../../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var CustomAvatar = function CustomAvatar(_ref) {
  var image = _ref.image,
    name = _ref.name,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return undefined;
    } : _ref$onClick,
    _ref$onMouseOver = _ref.onMouseOver,
    onMouseOver = _ref$onMouseOver === void 0 ? function () {
      return undefined;
    } : _ref$onMouseOver,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 40 : _ref$size,
    _ref$clinicianPatient = _ref.clinicianPatients,
    clinicianPatients = _ref$clinicianPatient === void 0 ? {} : _ref$clinicianPatient,
    className = _ref.className;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];

  // These patients are only available in clinician app, we need to replace nicknames for real names there
  var replacePatientName = (0, _utils.getSinglePatientNameByNickName)(name, clinicianPatients);
  if (replacePatientName) {
    name = replacePatientName;
  }

  // taking user name and image from message is for the case when Avatar is applied inside channel for Message rendering
  var userImageId = image;
  var imageSrc = (0, _react.useMemo)(function () {
    return userImageId ? (0, _endpoints.getCdnBucketImageUrl)(userImageId) : null;
  }, [userImageId]);
  (0, _react.useEffect)(function () {
    setError(false);
  }, [image]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(className, 'str-chat__custom-avatar rounded-full overflow-hidden flex justify-center items-center'),
    onClick: onClick,
    onMouseOver: onMouseOver,
    style: {
      flexBasis: "".concat(size, "px"),
      fontSize: "".concat(size * 0.325, "px"),
      // Based on 13px font size for 40px wide avatar
      height: "".concat(size, "px"),
      lineHeight: "".concat(size, "px"),
      width: "".concat(size, "px")
    }
  }, imageSrc && !error ? /*#__PURE__*/_react.default.createElement("img", {
    alt: name,
    className: "h-full",
    onError: function onError() {
      return setError(true);
    },
    src: imageSrc,
    style: {
      flexBasis: "".concat(size, "px"),
      height: "".concat(size, "px")
    }
  }) : /*#__PURE__*/_react.default.createElement(_components.AvatarFallback, {
    name: name,
    size: size,
    className: "w-full h-full"
  })));
};
exports.CustomAvatar = CustomAvatar;
var _default = CustomAvatar;
exports.default = _default;